import 'react'

import classNames from 'classnames'
import Link from 'next/link'

export interface CollapsibleGroupItemProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Custom styles.
   */
  className?: string
  /**
   * Navigation link url.
   */
  href?: string
  /**
   * If the link is active.
   */
  active?: boolean
  /**
   * Specifies where to open the linked page.
   */
  target?: string
}

export const CollapsibleGroupItem: React.FC<CollapsibleGroupItemProps> = ({
  className,
  href,
  active = false,
  target,
  children,
  ...props
}) => {
  const itemContent = (
    <div
      className={classNames('cb-sidenav-item', className, {
        active: active,
      })}
      {...props}
    >
      <span className={classNames('inner')}>{children}</span>
    </div>
  )

  return href ? (
    <Link className="block" href={href} target={target}>
      {itemContent}
    </Link>
  ) : (
    itemContent
  )
}

CollapsibleGroupItem.displayName = 'CollapsibleGroupItem'
